import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface IPostBody {
  attachId: number;
  name: string;
}

const useRenameFileApi = (isInvoices: boolean) => {
  const call = useCallback(
    (body?: IPostBody[]) =>
      new Promise<number[]>((resolve, reject) => {
        axiosInstance
          .post<number[]>(
            isInvoices ? api.changeInvoiceDocumentName : api.changeReceiptDocumentName,
            body
          )
          .then((data) => resolve(data.data))
          .catch((error) => {
            reject(error);
          });
      }),
    [isInvoices]
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    renameFile: execute,
    isRenameLoading: isLoading,
  };
};

export default useRenameFileApi;
